export enum ContentBlockToken {
  Model = 'content-block-model',
  MoveUp = 'content-block-move-up',
  MoveDown = 'content-block-move-down',
  Copy = 'content-block-copy',
  Remove = 'content-block-remove',
  CropFile = 'content-block-crop-file',
  EditFile = 'content-block-edit-file',
  ReplaceFile = 'content-block-replace-file',
  DeleteFile = 'content-block-delete-file',
  SpeakerIndex = 'content-block-speaker-index',
  UploadFileType = 'content-block-upload-file-type',
  SettingsId = 'content-block-settings-id',
  CloseSettings = 'content-block-close-settings',
}

export enum ContentBlockListItemToken {
  MoveUp = 'content-block-list-item-move-up',
  MoveDown = 'content-block-list-item-move-down',
  Remove = 'content-block-list-item-remove',
}
